import { Component, OnInit } from '@angular/core';

import { AlertService } from '../services/alert.service';

@Component({
    selector: 'global-message',
    templateUrl: './alert.component.html'
})

export class AlertComponent implements OnInit {
    message: any;

    constructor(private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.alertService.getMessage().subscribe(message => {
            this.message = message;
        });
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/directives/alert.component.ts